import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { debounceTime, Subject, take } from 'rxjs';
import { GlobalUser } from 'src/app/core/models/global.user.model';
import { ReleaseEntrance } from 'src/app/core/models/socketMessage';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MockService } from 'src/app/core/services/mock.service';
import { StudentService } from 'src/app/core/services/student.service';
import { TurnstileService } from 'src/app/core/services/turnstile.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'ds-unlock-access',
  templateUrl: './unlock-access.component.html',
  styleUrls: ['./unlock-access.component.scss']
})
export class UnlockAccessComponent implements OnInit {
  confirmResult!: Subject<boolean>;
  formUnlockAccess!: FormGroup;
  unitCode: any;
  programCodes;

  showName: boolean = false;

  @Input() public title: string = '';
  @Input() public isUnlockStudent: boolean = false;

  @Input() public student!: ReleaseEntrance;
  @Input() public unitCodeSelected: string;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private helpersService: HelpersService,
    private router: Router,
    private mockServie: MockService,
    private studentService: StudentService,
    private userService: UserService,
    private turnstileService: TurnstileService
  ) {}

  ngOnInit(): void {
    this.formUnlockAccess = new FormGroup({
      nationalId: this.fb.control('', [Validators.required, this.helpersService.validateCPF]),
      name: this.fb.control(''),
      profile: this.fb.control('1', Validators.required),
      reason: this.fb.control('', Validators.required),
      turnstileId: this.fb.control('', Validators.required),
      jwt: this.fb.control(this.helpersService.getDsAuthJWTToken().getValue(), Validators.required)
    });
    this.confirmResult = new Subject();

    this.formUnlockAccess.controls['nationalId'].statusChanges.pipe(debounceTime(500)).subscribe((status: string) => {
      if (status === 'VALID') {
        this.userService.getMyInfo().subscribe((user: GlobalUser) => {
          let unitCodes = user.nickName.split(':')[1].split('|');
          //this.unitCode = unitCodes[0];
          this.unitCode = this.unitCodeSelected ?? unitCodes[0];
          this.turnstileService.getTurnstilesByUnitCode(this.unitCode).subscribe((turnstileId) => {
            this.formUnlockAccess.patchValue({
              turnstileId: turnstileId.value[0].manufacturerId
            });
          });
        });
      }
      if (status === 'VALID' && !this.isUnlockStudent) {
        this.userService.getMyInfo().subscribe((user: GlobalUser) => {
          let unitCodes = user.nickName.split(':')[1].split('|');
          //this.unitCode = unitCodes[0];
          this.unitCode = this.unitCodeSelected ?? unitCodes[0];
          this.turnstileService
            .getTurnstilesByUnitCode(this.unitCode)
            .pipe(take(1))
            .subscribe((response) => {
              this.programCodes = response.value.map((programs) => String(programs.programsCodes)).toString();
              let nationalIDFormated = this.formUnlockAccess.get('nationalId')?.value.replaceAll('.', '').replaceAll('-', '');
              this.studentService.searchStudentByNationalId(nationalIDFormated).subscribe((student) => {
                if (student.value.length > 0) {
                  this.helpersService.reloadTo(this.router, `main/essential/student/${student.value[0].nationalId}`, {}, 'merge');
                  this.onClose();
                } else {
                  this.showName = true;
                  this.formUnlockAccess.get('name').setValidators(Validators.required);
                  this.formUnlockAccess.get('name').updateValueAndValidity();
                }
              });
            });
        });
      }
    });
  }

  onClose() {
    this.confirmAndClose(false);
  }

  onConfirm() {
    // Copiando o objeto do formulário e forçando a propriedade ser Number
    let sendFormUnlockAccess = Object.assign(this.formUnlockAccess.value);
    sendFormUnlockAccess.profile = Number(sendFormUnlockAccess.profile);

    this.confirmAndClose(sendFormUnlockAccess);
  }

  private confirmAndClose(value: any) {
    this.confirmResult.next(value);
    this.bsModalRef.hide();
  }
}
